import moment from "moment";
import React from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap"
import ModalHeader from "@dhn/components/molecules/modal-header";

export default function ModalShowDetail({ isOpen, toggle, dataSelected }) {
  return (
    <div className="animated fadeIn">
      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader
          toggle={toggle}
          iconClass="fa-stethoscope"
          description="Detalle de consulta"
          subtitle="Revise los datos registrados en la consulta."
        />
        <ModalBody>
          <Row form>
            <Col md="6">
              <Label>Fecha:</Label>
              <Input
                disabled
                value={moment(dataSelected?.date).format("DD/MM/YYYY")}
              />
            </Col>
          </Row>
          <Row form className="mt-4">
            <Col md="8">
              <Label>Médico:</Label>
              <Input
                disabled
                value={`${dataSelected?.medicalStaff?.firstName ?? ""} ${dataSelected?.medicalStaff?.lastName ?? ""}`}
              />
            </Col>
          </Row>
          <hr />
          <Row form className="mt-4">
            <Col className="d-flex flex-column">
              <Label>Motivo de la Consulta:</Label>
              <Input
                type="textarea"
                disabled
                value={dataSelected?.reason || ""}
              />
            </Col>
          </Row>
          <Row form className="mt-4">
            <Col className="d-flex flex-column">
              <Label>Historia de la Enfermedad:</Label>
              <Input
                type="textarea"
                disabled
                value={dataSelected?.diseaseHistory || ""}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" className="btn-color-danger" onClick={toggle}>
            <i className="fa fa-times" aria-hidden="true" />
            {" Cerrar"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
